export type LegalNatureType = 'F' | 'J';

export enum legalNature {
  FISICAL = 'F',
  JURIDICAL = 'J',
}
